module.exports = __webpack_public_path__ + "img/HeritageHubSpeciesViewer20220805_MOBILE.4a534f7a.jpg";